export default "__VITE_ASSET__CfGPzlBW__"